import { render, staticRenderFns } from "./billiardTableDetail.vue?vue&type=template&id=8dbe9b8e"
import script from "./billiardTableDetail.vue?vue&type=script&lang=js"
export * from "./billiardTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports